import { css } from 'styled-components';
const offscreen = css(["position:absolute;width:1px;height:1px;margin:-1px;clip:rect(0,0,0,0);white-space:nowrap;border-width:0;"]);
const notOffscreen = css(["position:static;padding:auto;clip:auto;width:auto;height:auto;white-space:normal;"]);
export const offscreenFocusable = css(["", " &:focus{", "}"], offscreen, notOffscreen);